module.exports = __webpack_public_path__ + "assets/img/head2-en.010cde18.png";